import Effects from "./effects";
const myEffects = new Effects();
export default myEffects;